// src/Pages/Auth/Login.jsx
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import Button from "@mui/material/Button";
import { mobile_login } from "../../api/User";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Navbar from "../../Navbar/Navbar";

const Login = ({ setIsSidebar }) => {
  const [isPass, setIsPass] = useState(true);
  const [role, setRole] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [password, setPassword] = useState("");
  const [mobileError, setMobileError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (setIsSidebar) {
      setIsSidebar(false);
    }
  }, [setIsSidebar]);

  const handlePassword = () => setIsPass((p) => !p);

  const handleMobileChange = (e) => {
    const raw = e.target.value || "";
    let digits = raw.replace(/\D/g, "");
    if (digits.length > 10) digits = digits.slice(0, 10);
    setMobileNumber(digits);
    if (digits.length === 0) {
      setMobileError("");
    } else if (digits.length < 10) {
      setMobileError("Mobile number must be 10 digits.");
    } else {
      setMobileError("");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!role) { toast.error("Please select a role."); return; }
    if (!mobileNumber) { toast.error("Please enter mobile number."); return; }
    if (mobileNumber.length !== 10) { toast.error("Mobile number must be exactly 10 digits."); return; }
    if (!password) { toast.error("Please enter password."); return; }

    const data = { uid: mobileNumber, password, role };

    try {
      const res = await mobile_login(data);
      if (res.status === "success") {
        sessionStorage.setItem("token", res.token);
        sessionStorage.setItem("gp_data", res.gp_data);
        sessionStorage.setItem("role_id", res.role_id);
        sessionStorage.setItem("user_id", res.user_id);
        sessionStorage.setItem("role", res.role);
        sessionStorage.setItem("username", res.username);
        toast.success(res.message);

        if (setIsSidebar) setIsSidebar(true);

        if (res.role_id == 2) {
          navigate("/gram-sabha-meeting");
        } else if (res.role_id == 1) {
          navigate("/ViewMeetingForGramSabhaAdmin");
        } else if (res.role_id == 4) {
          navigate("/view-gram-panchayat-meeting");
        } else if (res.role_id == 7 || res.role_id == 8 || res.role_id == 3) {
          navigate("/ViewMeetingForGramSabhaAdmin");
        } else if (res.role_id == 5) { // Add this for SEWA
          navigate("/ceozp-report"); // Navigate directly to CEO-ZP report
        }
        else if (res.role_id == 6) { // Add this for HPPA
          navigate("/ceozp-report"); // Navigate directly to CEO-ZP report
        }
        else {
          navigate("/");
        }
      } else {
        toast.error(res.message || "Login failed");
      }
    } catch (error) {
      console.error("Error login:", error);
      if (error && error.message) toast.error(error.message);
      else toast.error("Error during login. Check console.");
    }
  };

  return (
    <>
      <Navbar isSidebar={false} />
      <div style={{
        minHeight: "90vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#ffffff",
        padding: "16px",
        boxSizing: "border-box",
        overflow: "hidden"
      }}>
        <div style={{
          display: "flex",
          width: "100%",
          maxWidth: "900px",
          backgroundColor: "#fff",
          borderRadius: "12px",
          boxShadow: "0 10px 40px rgba(0,0,0,0.2)",
          overflow: "hidden"
        }}>
          {/* Left Panel - Branding */}
          <div style={{
            flex: "1",
            background: "linear-gradient(180deg, #0D1642 0%, #1a237e 100%)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "24px",
            color: "white"
          }}>
            <img src="logo.png" alt="Logo" style={{ width: "190px", marginBottom: "16px" }} />
            <h5 style={{ margin: "0 0 8px 0", fontSize: "16px", fontWeight: "600", textAlign: "center" }}>
              Department of Panchayat
            </h5>

            <img src="bottom.png" alt="Illustration" style={{ width: "100%", maxWidth: "200px", marginTop: "auto" }} />
          </div>

          {/* Right Panel - Login Form */}
          <div style={{
            flex: "1",
            padding: "32px 28px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center"
          }}>
            <h4 style={{ margin: "0 0 20px 0", fontSize: "22px", fontWeight: "600", color: "#0D1642", textAlign: "center" }}>
              Login
            </h4>

            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: "14px" }}>
                <label style={{ fontSize: "13px", fontWeight: "500", color: "#333", display: "block", marginBottom: "4px" }}>
                  Select Role
                </label>
                <select
                  value={role}
                  onChange={(e) => setRole(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "10px 12px",
                    fontSize: "13px",
                    border: "1px solid #ddd",
                    borderRadius: "6px",
                    outline: "none",
                    backgroundColor: "#fff"
                  }}
                >
                  <option value="" disabled>Select Role</option>
                  <option value="1">Admin</option>
                  <option value="2">Gram Sachiv</option>
                  <option value="7">BDPO</option>
                  <option value="8">CEO-ZP</option>
                  <option value="3">Sarpanch</option>
                  <option value="5">SEWA</option>
                  <option value="6">HPPA</option>
                </select>
              </div>

              <div style={{ marginBottom: "14px" }}>
                <label style={{ fontSize: "13px", fontWeight: "500", color: "#333", display: "block", marginBottom: "4px" }}>
                  Mobile Number
                </label>
                <input
                  type="text"
                  value={mobileNumber}
                  onChange={handleMobileChange}
                  placeholder="Enter 10-digit mobile number"
                  inputMode="numeric"
                  style={{
                    width: "100%",
                    padding: "10px 12px",
                    fontSize: "13px",
                    border: "1px solid #ddd",
                    borderRadius: "6px",
                    outline: "none",
                    boxSizing: "border-box"
                  }}
                />
                {mobileError && <span style={{ color: "#e53935", fontSize: "11px", marginTop: "4px", display: "block" }}>{mobileError}</span>}
              </div>

              <div style={{ marginBottom: "18px" }}>
                <label style={{ fontSize: "13px", fontWeight: "500", color: "#333", display: "block", marginBottom: "4px" }}>
                  Password
                </label>
                <div style={{ position: "relative" }}>
                  <input
                    type={isPass ? "password" : "text"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Enter password"
                    style={{
                      width: "100%",
                      padding: "10px 40px 10px 12px",
                      fontSize: "13px",
                      border: "1px solid #ddd",
                      borderRadius: "6px",
                      outline: "none",
                      boxSizing: "border-box"
                    }}
                  />
                  <span
                    onClick={handlePassword}
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "#666"
                    }}
                  >
                    {isPass ? <RemoveRedEyeIcon fontSize="small" /> : <VisibilityOffIcon fontSize="small" />}
                  </span>
                </div>
              </div>

              <Button
                type="submit"
                variant="contained"
                fullWidth
                sx={{
                  padding: "10px",
                  fontSize: "14px",
                  fontWeight: "600",
                  backgroundColor: "#4763E4",
                  borderRadius: "6px",
                  textTransform: "none",
                  "&:hover": { backgroundColor: "#3451c7" }
                }}
              >
                Login
              </Button>
            </form>
          </div>
        </div>
        <ToastContainer toastClassName="custom-toast" />
      </div>
    </>
  );
};

export default Login;
